import { z } from 'zod';

import { NotificationChannel } from '@/api/fe-api/domain/entities/alert-notifications';
import { AlertStatus } from '@/entities/alert-status';

export const formCreateSchema = z.object({
  enabled: z.boolean(),
  title: z.string().min(1, { message: 'Required' }),
  minAlertStatus: z.enum([
    AlertStatus.OK,
    AlertStatus.INFO,
    AlertStatus.WARNING,
    AlertStatus.TRIPPED,
    AlertStatus.CRITICAL,
  ]),
  assets: z.array(z.string()),
  channels: z.record(
    z.enum([
      NotificationChannel.Email,
      NotificationChannel.Slack,
      NotificationChannel.Webhook,
      NotificationChannel.SMS,
      NotificationChannel.SFTP,
    ]),
    z.boolean(),
  ),
  frequency: z.enum(['Daily', 'NewAlerts']),
  recipients: z.array(z.string().email('Invalid email address')),
});

export type FormCreateInputs = z.infer<typeof formCreateSchema>;

export const defaultValues: Partial<FormCreateInputs> = {
  enabled: true,
  title: undefined,
  minAlertStatus: AlertStatus.WARNING,
  assets: [],
  channels: {
    [NotificationChannel.Email]: true,
    [NotificationChannel.Slack]: false,
    [NotificationChannel.Webhook]: false,
    [NotificationChannel.SMS]: false,
    [NotificationChannel.SFTP]: false,
  },
  frequency: 'NewAlerts',
  recipients: [],
};
